import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { SITE_URL } from "@/lib/seo";
import { getKeywordBlock } from "@/data/seoKeywords";

export const KeywordSpotlight = ({ type, id, extra }) => {
  const { pathname } = useLocation();
  const block = getKeywordBlock(type, id, extra);
  const keywords = block ? block.keywords.join(", ") : "";

  useEffect(() => {
    if (!keywords) return undefined;
    let tag = document.head.querySelector('meta[name="keywords"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "keywords");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", keywords);
    return () => tag.remove();
  }, [keywords]);

  if (!block) return null;
  const url = `${SITE_URL}${pathname === "/" ? "" : pathname.replace(/\/$/, "")}`;
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${url}#sourcing-service`,
    name: block.heading,
    serviceType: block.keywords,
    description: block.paragraphs[0],
    url,
    provider: { "@type": "Organization", name: "Asia Sourcing", url: SITE_URL },
    areaServed: ["United States", "United Kingdom", "European Union", "Australia", "Middle East"].map((name) => ({ "@type": "Place", name })),
  };

  return (
    <section className="wrap" data-testid="keyword-spotlight" aria-label={block.heading} style={{ paddingBlock: "2.5rem", borderTop: "1px solid var(--line)" }}>
      <p className="eyebrow" style={{ fontFamily: "var(--mono)", fontSize: ".72rem", letterSpacing: ".12em", textTransform: "uppercase" }}>Related sourcing searches</p>
      <h2 style={{ marginTop: ".5rem", fontSize: "1.15rem" }} data-testid="keyword-spotlight-heading">{block.heading}</h2>
      {block.paragraphs.map((p, i) => (
        <p key={i} style={{ maxWidth: "75ch", marginTop: ".8rem", lineHeight: 1.7 }}>{p}</p>
      ))}
      <ul style={{ display: "flex", flexWrap: "wrap", gap: ".6rem 1.2rem", listStyle: "none", padding: 0, marginTop: "1.2rem" }}>
        {block.links.map(([to, text]) => (
          <li key={to}>
            <Link to={to} data-testid={`keyword-link-${to.replace(/\//g, "-").replace(/^-/, "")}`} style={{ textDecoration: "underline", textUnderlineOffset: "3px" }}>{text}</Link>
          </li>
        ))}
      </ul>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    </section>
  );
};

export default KeywordSpotlight;
